import { ReimbutsementErrorsEnum } from "@reimbursement/batch/enums/ReimbursementErrorCode"

export const errorResolver = (errorCode: ReimbutsementErrorsEnum) => {
    if(errorCode === ReimbutsementErrorsEnum.REIMBURSEMENT_INVALID_STATUS) {
        return "Status de lote inválido, verifique se o mesmo já foi validado ou excluído"
    }
    return "Erro inesperado";
}